import quality from "./images/quality.svg";
import honesty from "./images/honesty.svg";
import sustainability from "./images/sustainability.svg";
import trust from "./images/trust.svg";
import diversity from "./images/diversity.svg";

const coreValuesData = [
  {
    title: "Authenticity & Quality",
    description:
      "A commitment to sourcing and providing high-quality and authentic products to customers.",
    image: quality,
  },
  {
    title: "Honesty & Integrity",
    description:
      "Operating with transparency and adhering to ethical business practices.",
    image: honesty,
  },
  {
    title: "Sustainability & Community Support",
    description:
      "A focus on reducing their carbon footprint, supporting fair trade practices and giving back to the community.",
    image: sustainability,
  },
  {
    title: "Trust & Transparency",
    description:
      "Building trust with customers through open and honest communication.",
    image: trust,
  },
  {
    title: "Diversity & Inclusiveness",
    description:
      "Embracing diversity and creating a welcoming and inclusive environment for all customers and employees.",
    image: diversity,
  },
];

export { coreValuesData };
